function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobilepay = function SvgMobilepay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.23 25.06",
    style: {
      enableBackground: "new 0 0 36.23 25.06"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a9c2d1"
    },
    d: "M33.23 1c1.103 0 2 .897 2 2v19.06c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h30.23m0-1H3a3 3 0 0 0-3 3v19.06a3 3 0 0 0 3 3h30.23a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a78ff"
    },
    d: "M-16.425 21.03c-.581 0-1.105-.35-1.328-.887l-4.96-11.975a1.436 1.436 0 0 1 .776-1.877l5.196-2.152a1.436 1.436 0 0 1 1.876.777l4.96 11.976a1.436 1.436 0 0 1-.776 1.876l-5.196 2.153a1.43 1.43 0 0 1-.548.109zm.234-16.227a.661.661 0 0 0-.254.05l-5.196 2.153a.663.663 0 0 0-.359.866l4.961 11.975c.14.338.528.499.866.36l5.196-2.154a.663.663 0 0 0 .358-.866l-4.96-11.975a.664.664 0 0 0-.612-.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -184.986,
    y1: 23.169,
    x2: -184.977,
    y2: 23.358,
    gradientTransform: "matrix(2.89821 -1.20048 -7.969 -19.23887 707.354 233.141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#mobilepay_svg__a)",
      enableBackground: "new"
    },
    d: "m-15.252 6.002.715-.296 1.964 4.742-.715.296z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: -273.86,
    y1: 26.689,
    x2: -273.851,
    y2: 26.878,
    gradientTransform: "matrix(-2.89821 1.20048 9.02061 21.77769 -1046.731 -240.307)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.616
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.283
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.076
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#mobilepay_svg__b)",
      enableBackground: "new"
    },
    d: "m-10.234 16.096-.715.296-2.223-5.368.714-.296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a78ff"
    },
    d: "M-11.85 12.834c-1.487.616-2.727 1.465-3.54 2.49l-2.094-5.06a8.844 8.844 0 0 1 3.539-2.489c1.486-.616 2.987-.914 4.262-.74l2.095 5.058a8.84 8.84 0 0 0-4.263.74z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 11)",
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: -246.957,
    y1: 15.013,
    x2: -246.85,
    y2: 15.074,
    gradientTransform: "matrix(40.154 0 0 -33.82774 9879.188 509.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.872
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.536
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "url(#mobilepay_svg__c)",
      enableBackground: "new"
    },
    d: "M-32.85 1.834c-1.487.616-2.727 1.465-3.54 2.49l-2.094-5.06a8.844 8.844 0 0 1 3.539-2.489c1.486-.616 2.987-.914 4.262-.74l2.095 5.058a8.84 8.84 0 0 0-4.263.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: -246.873,
    y1: 15.09,
    x2: -246.879,
    y2: 15.131,
    gradientTransform: "matrix(40.154 0 0 -33.82774 9879.188 509.352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#504678"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    style: {
      stopColor: "#504678",
      stopOpacity: 0.332
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#504678",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#mobilepay_svg__d)",
      enableBackground: "new"
    },
    d: "M-32.85 1.834c-1.487.616-2.727 1.465-3.54 2.49l-2.094-5.06a8.844 8.844 0 0 1 3.539-2.489c1.486-.616 2.987-.914 4.262-.74l2.095 5.058a8.84 8.84 0 0 0-4.263.74z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5a78ff"
    },
    d: "M-11.168 14.376c-1.609 0-3.081.31-4.222.945v-5.114a8.844 8.844 0 0 1 4.222-.946c1.608 0 3.11.299 4.221.947v5.114a8.84 8.84 0 0 0-4.221-.946z"
  })));
};
export { SvgMobilepay as ReactComponent };
export default __webpack_public_path__ + "9550f7a5.svg";